import React from 'react';
import './icon.scss';

export const AvailableIcon = () => {
  return (
    <img
      src="https://assets.homedepot-static.com/images/v1/Available.svg"
      alt="Available Shipping"
      className="icon__size"
    />
  );
};

export const BopisOffIcon = () => {
  return (
    <img
      src="https://assets.homedepot-static.com/images/v1/BOPIS-Off.svg"
      alt="Buy in Store"
      className="icon__size"
    />
  );
};

export const InStockIcon = () => {
  return (
    <img
      src="https://assets.homedepot-static.com/images/v1/In-Stock.svg"
      alt="Available for pickup"
      className="icon__size"
    />
  );
};

export const LimitedStockIcon = () => {
  return (
    <img
      src="https://assets.homedepot-static.com/images/v1/Limited-Stock.svg"
      alt="Limited stock for pickup"
      className="icon__size"
    />
  );
};

export const UnavailableIcon = () => {
  return (
    <img
      src="https://assets.homedepot-static.com/images/v1/close-x-black.svg"
      alt="Limited stock for pickup"
      className="icon__unavailable"
    />
  );
};
